import React from 'react';
import { LucideIcon } from 'lucide-react';

interface BadgeProps {
  variant?: 'success' | 'warning' | 'error' | 'info' | 'neutral';
  icon?: LucideIcon;
  children: React.ReactNode;
  className?: string;
  size?: 'sm' | 'md';
}

export const Badge: React.FC<BadgeProps> = ({
  variant = 'info',
  icon: Icon,
  children,
  className = '',
  size = 'md',
}) => {
  const variantClasses = {
    success: 'bg-emerald-500/10 dark:bg-emerald-500/20 text-emerald-600 dark:text-emerald-400 border-emerald-500/20',
    warning: 'bg-orange-500/10 dark:bg-orange-500/20 text-orange-600 dark:text-orange-400 border-orange-500/20',
    error: 'bg-red-500/10 dark:bg-red-500/20 text-red-600 dark:text-red-400 border-red-500/20',
    info: 'bg-blue-500/10 dark:bg-blue-500/20 text-blue-600 dark:text-blue-400 border-blue-500/20',
    neutral: 'bg-gray-100 dark:bg-white/[0.06] text-gray-600 dark:text-white/60 border-gray-200 dark:border-white/[0.08]',
  };

  const sizeClasses = {
    sm: 'px-2 py-0.5 text-[10px]',
    md: 'px-3 py-1 text-xs',
  };

  return (
    <span className={`rounded-full font-semibold border inline-flex items-center gap-1 ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}>
      {Icon && <Icon size={size === 'sm' ? 10 : 12} />}
      {children}
    </span>
  );
};
